import { GlIcon, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import workItemRequesterQuery from '../graphql/work_item_requester.query.graphql';
import { findRequesterWidget } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/utils.js?vue3';
import WorkItemSidebarWidget from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/shared/work_item_sidebar_widget.vue?vue3';
export default {
    name: 'WorkItemRequester',
    components: {
        GlIcon,
        GlLink,
        WorkItemSidebarWidget
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        workItemIid: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            requester: null
        };
    },
    apollo: {
        requester: {
            query: workItemRequesterQuery,
            variables () {
                return {
                    fullPath: this.fullPath,
                    iid: this.workItemIid
                };
            },
            update (data) {
                const workItem = data?.namespace?.workItem ?? {};
                return findRequesterWidget(workItem);
            },
            skip () {
                return !this.workItemIid;
            }
        }
    },
    computed: {
        email () {
            return this.requester?.email;
        }
    }
};
